import React from 'react';



const Footer = () => {
  return (
    <footer>
      <p id="pagetop"><a href="#root"><img src="/assets/img/pagetop.png" alt="TOPへ" /></a></p>
      <section className="nav">
        <ul>
          <li><a href="https://ffxiv-pt.com/" target="_blank" rel="noopener noreferrer"><img src="/assets/img/bnr_pt.png" alt="FFXIV PARTY FINDER" /></a></li>
        </ul>
      </section>
      <div className="footerBtm">
        <small>&copy; 2026 FFXIV.LINK<br />記載されている会社名・製品名・システム名などは、各社の商標、または登録商標です。<br />Copyright (C) 2010 - 2026 SQUARE ENIX CO., LTD. All Rights Reserved.<br /><a href="https://vast.jp/tokusho.html" target="_blank" rel="noopener noreferrer">特定商取引法に基づく表記</a></small>
      </div>
    </footer>
  );
};

export default Footer;